import {useI18n} from '@logistics-frontend/core/i18n'
import {ButtonProps, Grid, ListItem as Slot, PlusIcon, Text, Trail, Typography} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './PaymentCardAddButton.classes'

export const PaymentCardAddButton = memo(function PaymentCardAddButton(props: ButtonProps): React.ReactElement {
  const pressHandler = props.onPress as VoidFunction
  const t = useI18n()

  return (
    <Slot dividerOffset="m" onPress={pressHandler} size="l">
      <Text
        // @ts-expect-error пропс Component не унаследован от Box, но он есть
        Component={Typography}
        thickness="medium"
        variant="body2"
      >
        {t('card_list_form.add_new_card', 'Добавить карту')}
      </Text>
      <Trail mr="m">
        <Grid alignItems="center" className={classes.mobileIcon} justify="center" container>
          <PlusIcon />
        </Grid>
      </Trail>
    </Slot>
  )
})
